import React, { useState } from "react";
import axios from "axios";
import Papa from "papaparse";
import { Container, Form, Button, ProgressBar, Alert } from "react-bootstrap";

function UploadAndValidateCSV() {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setProgress(0);
    setMessage("");
  };

  const handleFileUpload = () => {
    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const rows = results.data;

        let totalRows = rows.length;
        let processedCount = 0;

        for (const row of rows) {
          try {
            await axios.post("https://api.eyorsolutions.com/api/upload-csv", row);
            processedCount++;
            setProgress((processedCount / totalRows) * 100);
          } catch (error) {
            console.error("Error processing row:", row, error);
          }
        }

        setMessage("CSV file processed successfully.");
      },
    });
  };

  return (
    <Container className="py-4">
      <h1 className="mb-4">Upload & Validate CSV</h1>

      <Form.Group controlId="csvUpload" className="mb-4">
        <Form.Label>Upload CSV File</Form.Label>
        <Form.Control
          type="file"
          accept=".csv"
          onChange={handleFileChange}
        />
      </Form.Group>

      <Button
        onClick={handleFileUpload}
        disabled={!file}
        variant="primary"
        className="mb-4"
      >
        Upload & Validate
      </Button>

      {progress > 0 && (
        <ProgressBar now={progress} label={`${progress.toFixed(2)}%`} />
      )}

      {message && <Alert className="mt-4">{message}</Alert>}
    </Container>
  );
}

export default UploadAndValidateCSV;
